<template>
  <div>
    <el-row style="margin: 0 auto;">
      <el-col :span="22">
        <el-form ref="searchForm" :model="searchForm" style="display: flex;column-gap: 20px;">
          <el-form-item>
            <div>
              <el-date-picker
                v-model="searchForm.date"
                type="daterange"
                size="mini"
                class="w300"
                :clearable="false"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions">
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item v-if="showMarket">
            <el-select
                v-model="searchForm.market_id"
                size="mini"
                value-key="market_id"
                placeholder="请选择"
                filterable
              >
              <el-option
                v-for="item in marketList"
                :key="item.market_id"
                :label="item.market_name"
                :value="item.market_id"
              />
            </el-select>
          </el-form-item>
        </el-form>  
      </el-col>
      <el-col :span="2">
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleSearch">搜索</el-button>
      </el-col>
    </el-row>
    
    <!-- 每日业绩图表 -->
    <div class="charts-container" v-loading="loadingStates.dailyPerform">
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 3%;">{{name}}每日业绩</div>
            <div id="qMain8" class="chart-content" />
          </div>
        </el-col>
      </el-row>        
    </div>
    <div class="charts-container" v-loading="loadingStates.ratingByMarket">
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 3%;">{{name}}评价问题分值
             <el-tooltip content="
              该数据取自中台系统 服务评价中最近3个月的评价记录" placement="top">
              <i class="el-icon-question" style="margin-left:6px; color:#fff; cursor:pointer;"></i>
            </el-tooltip></div>
            <div id="qMain9" class="chart-content" />
          </div>
        </el-col>
        <el-col :span="12">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 3%;">{{name}}各店铺评价分值
             <el-tooltip content="
              该数据取自中台系统 服务评价中最近3个月的评价记录" placement="top">
              <i class="el-icon-question" style="margin-left:6px; color:#fff; cursor:pointer;"></i>
            </el-tooltip>
            </div>
            <div id="qMain10" class="chart-content" />
          </div>
        </el-col>
      </el-row>        
    </div>
    
    <div class="charts-container" v-loading="loadingStates.questionDetail">
      <el-row>
        <el-col :span="24" class="table-container">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">{{name}}门店评价表
             <el-tooltip content="
              该数据取自中台系统 服务评价中最近3个月的评价记录" placement="top">
              <i class="el-icon-question" style="margin-left:6px; color:#fff; cursor:pointer;"></i>
            </el-tooltip></div>
            <el-table 
              :data="shopScoreList"
              border
              size="small"
              :default-sort = "{prop: 'receipts', order: 'descending'}"
              :cell-style="$style.cellStyle"
              :row-class-name="tableRowClassName"
              :header-cell-style="$style.rowClass"
          >
            <!-- 门店列 -->
            <el-table-column
              label="门店名称"
              prop="shop_name"
              width="120"
              align="center"
            />

            <!-- 循环生成问题评分列 -->
            <el-table-column
              v-for="(question, index) in questionList1"
              :key="question.question_id"
              :label="question.title"
              align="center"
              min-width="180"
            >
              <template slot-scope="scope">
                <!-- 取出当前门店对应问题的分数 -->
                <span>{{ scope.row.scores[index].score }}</span>
              </template>
            </el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>
    </div>
    
  
    <!-- 各渠道总销售情况 + 订单人数 -->
    <div class="charts-container" v-loading="loadingStates.channelData">
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 3%;">{{name}}各渠道总销售情况(新单+补单)</div>
            <div id="qMain1" class="chart-content" />
          </div>
        </el-col>
        <el-col :span="12">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 3%;">{{name}}各渠道订单人数(老客+新客)</div>
            <div id="qMain2" class="chart-content" />
          </div>
        </el-col>
      </el-row>        
    </div>
    <!-- 各渠道新客进店数据 -->
    <div class="charts-container" v-loading="loadingStates.channelEnter">
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="chart-wrapper">
            <div class="table-title" >{{name}}各渠道新客进店数据(客资+进店)</div>
            <div id="qMain3" class="chart-content" />
          </div>
        </el-col>
      </el-row>        
    </div>
    
    <!-- 各渠道(新客)进店数+成交数对比 -->
    <div class="charts-container" v-loading="loadingStates.channelEnter">
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="chart-wrapper">
            <div class="table-title" >{{name}}各渠道(新客)进店数+成交数对比</div>
            <div id="qMain6" class="chart-content" />
          </div>
        </el-col>
        <el-col :span="0">
          <div class="chart-wrapper">
            <div class="table-title" >{{name}}各渠道总成交人数(老客+新客)</div>
            <div id="qMain5" class="chart-content" />
          </div>
        </el-col>
      </el-row>        
    </div>
    
    <!-- 各渠道数据表（新客） -->
    <div class="charts-container" v-loading="loadingStates.channelEnter">
      <el-row>
          <el-col :span="24" class="table-container">
            <div class="chart-wrapper">
              <div class="table-title" style="margin-bottom: 2%;">{{name}}各渠道数据表（新客）</div>
              <el-table
                :data="newList"
                :default-sort = "{prop: 'proceeds_balance', order: 'descending'}"
                border
                size="small"
                :cell-style="$style.cellStyle"
                :row-class-name="tableRowClassName"
                :header-cell-style="$style.rowClass"
                >
                <el-table-column prop="name" label="来源" width="120"/>
                <el-table-column prop="proceeds_balance" label="渠道业绩" width="120" sortable/>

                <el-table-column label="渠道销售占比" width="150" sortable>   
                  <template slot-scope="{row}">
                    {{row.proceeds_rete}}%
                  </template>      
                </el-table-column>                  
                <el-table-column prop="gainCount" label="获客人数" width="120" sortable/>
                <el-table-column prop="bhGainCount" label="疤痕" sortable/>
                <el-table-column prop="ddGainCount" label="痘痘" sortable />
                <el-table-column prop="pfGainCount" label="皮肤" sortable />
                <el-table-column prop="enterCount" label="进店人数" width="120" sortable />
                <el-table-column prop="bhEnterCount" label="疤痕" sortable/>
                <el-table-column prop="ddEnterCount" label="痘痘" sortable />
                <el-table-column prop="pfEnterCount" label="皮肤" sortable />
                <el-table-column prop="cjCount" label="成交人数" width="120" sortable />
                <el-table-column prop="bhCjCount" label="疤痕" sortable/>
                <el-table-column prop="ddCjCount" label="痘痘" sortable />
                <el-table-column prop="pfCjCount" label="皮肤" sortable />
                <el-table-column label="成交转化率" width="150" sortable>
                  <template slot-scope="{row}">
                    {{row.cj_rate}}%
                  </template>        
                </el-table-column>     
              </el-table>
            </div>
          </el-col>
      </el-row>
    </div>
    
    <!-- 各渠道顾客成交情况(老客+新客) -->
    <div class="charts-container" v-loading="loadingStates.channelData">
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="chart-wrapper">
            <div class="table-title">{{name}}各渠道顾客成交情况(老客+新客)</div>
            <div id="qMain7" class="chart-content" />
          </div>
        </el-col>
      </el-row>        
    </div>
    
    <!-- 各渠道数据表（新客+老客） -->
    <div class="charts-container" v-loading="loadingStates.channelData">
      <el-row>
        <el-col :span="24" class="table-container">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">{{name}}各渠道数据表（新客+老客）</div>
            <el-table
              :data="allList"
              border
              size="small"
              :default-sort = "{prop: 'perform', order: 'descending'}"
              :cell-style="$style.cellStyle"
              :row-class-name="tableRowClassName"
              :header-cell-style="$style.rowClass"
              >
              <el-table-column prop="name" label="来源" width="150"/>
              <el-table-column prop="perform" label="渠道业绩" sortable/>
              <el-table-column label="渠道销售占比" sortable>   
                <template slot-scope="{row}">
                  {{row.proceeds_rete}}%
                </template>      
              </el-table-column>     
              <el-table-column prop="cjCount" label="订单人数" sortable/>
              <el-table-column prop="bhCjCount" label="疤痕" sortable/>
              <el-table-column prop="ddCjCount" label="痘痘" sortable />
              <el-table-column prop="pfCjCount" label="皮肤" sortable/>
              <el-table-column prop="order_avg_price" label="客单价" sortable />
            </el-table>
          </div>
        </el-col>
      </el-row>
    </div>
    
    <!-- 服务销售表 + 商品销售表 -->
    <div class="charts-container" v-loading="loadingStates.serviceGoods">
      <el-row :gutter="20">
        <el-col :span="12" class="table-container">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom:3%;">{{name}}服务销售表</div>
            <el-table
              :data="serviceList"
              height="600"
              size="small"
              :default-sort = "{prop: 'pay_amount', order: 'descending'}"
              :row-class-name="tableRowClassName"
              >
              <el-table-column prop="name" label="服务名称" width="150"/>
              <el-table-column prop="pay_amount" label="销售本金" align="center"  sortable />
              <el-table-column prop="gift_amount" label="销售赠金" align="center" sortable />
              <el-table-column prop="num" label="销售数量" align="center" sortable />
              <el-table-column prop="cj_num" label="成交人数" align="center" sortable/>
              <el-table-column prop="service_num" label="次数" align="center" sortable />
              <el-table-column prop="once_avg_price" label="单次均价"  width="120" align="center" sortable/>
            </el-table>
          </div>
        </el-col>
        <el-col :span="12" class="table-container">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 3%;">{{name}}商品销售表</div>
            <el-table
              :data="goodsList"
              height="600"
              size="small"
              :row-class-name="tableRowClassName"
              :default-sort = "{prop: 'pay_amount', order: 'descending'}"
              >
              <el-table-column prop="name" label="产品名称"  width="220"/>
              <el-table-column prop="pay_amount" label="销售本金"  align="center"  sortable />
              <el-table-column prop="gift_amount" label="销售赠金"  align="center"  sortable />
              <el-table-column prop="num" label="销售数量"  align="center"  sortable/>
              <el-table-column prop="cj_num" label="成交人数"   align="center" sortable />
            </el-table>
          </div>
        </el-col>
      </el-row>
    </div>
    
    <!-- 核销业绩 + 护理人数 -->
    <div class="charts-container" v-loading="loadingStates.shopPerform">
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">{{name}}核销业绩</div>
            <div id="nMain1" class="chart-content" />
          </div>
        </el-col>
        <el-col :span="12">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">{{name}}护理人数
                    <ElTooltip content="统计的是当前时间段内护理的人数（当前时间段内同一个客户护理多次只统计1次）" placement="top">
                      <i class="el-icon-question" style="color: #fff; cursor: pointer"></i>
                    </ElTooltip></div>
            <div id="nMain2" class="chart-content" />
          </div>
        </el-col>
      </el-row>        
    </div>
    
    <!-- 门店业绩与消耗额分析 + 门店业绩与赠金分析 -->
    <div class="charts-container" v-loading="loadingStates.shopPerform">
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">{{name}}门店业绩与消耗额分析</div>
            <div id="nMain3" class="chart-content" />
          </div>
        </el-col>
        <el-col :span="12">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">{{name}}门店业绩与赠金分析</div>
            <div id="nMain4" class="chart-content" />
          </div>
        </el-col>
      </el-row>        
    </div>
    
    <!-- 门店新单补单业绩 + 门店护理量/人头数/护理金额分析 -->
    <div class="charts-container" v-loading="loadingStates.shopPerform">
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">{{name}}门店新单补单业绩</div>
            <div id="nMain5" class="chart-content" />
          </div>
        </el-col>
        <el-col :span="12">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">{{name}}门店护理人数
                    <ElTooltip content="统计的是当前时间段内护理的人数（当前时间段内同一个客户护理多次只统计1次）" placement="top">
                      <i class="el-icon-question" style="color: #fff; cursor: pointer"></i>
                    </ElTooltip>/护理量/护理金额分析</div>
            <div id="nMain6" class="chart-content" />
          </div>
        </el-col>
      </el-row>        
    </div>
    
    <!-- 服务核销数据 -->
    <div class="charts-container" v-loading="loadingStates.realService">
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">{{name}}服务核销数据</div>
            <div id="nMain7" class="chart-content" />          
          </div>
        </el-col>
      </el-row>        
    </div>
    
    <!-- 产品出库明细 -->
    <div class="charts-container" v-loading="loadingStates.realGoods">
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">{{name}}产品出库明细</div>
            <div id="nMain8" class="chart-content" />          
          </div>
        </el-col>
      </el-row>        
    </div>
    
    <!-- 服务消耗表 + 产品出库表 -->
    <div class="charts-container" v-loading="loadingStates.realService">
      <el-row :gutter="20">
        <el-col :span="12" class="table-container">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom:3%;">{{name}}服务消耗表</div>
            <el-table
              :data="realServiceList"
              height="600"
              size="small"
              :default-sort = "{prop:'consume_count', order: 'descending'}"
              :row-class-name="tableRowClassName"
              >
              <el-table-column prop="name" label="服务名称" width="180"/>
              <el-table-column prop="consume_bj" label="核销金额（本金）" align="center"  sortable />
              <el-table-column prop="consume_count" label="核销数量" align="center" sortable />
              <ElTableColumn label="护理人数" prop="serve_num" align="center"  sortable>
                <template #header>
                  <div style="display: flex; align-items: center; ">
                    护理人数
                    <ElTooltip content="统计的是当前时间段内护理的人数（当前时间段内同一个客户护理多次只统计1次）" placement="top">
                      <i class="el-icon-question" style="color: #909399; cursor: pointer"></i>
                    </ElTooltip>
                  </div>
                </template>
              </ElTableColumn>
              <el-table-column prop="once_serve_amount" label="单次护理金额"   align="center" sortable/>
            </el-table>
          </div>
        </el-col>
        <el-col :span="12" class="table-container">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 3%;">{{name}}产品出库表</div>
            <el-table
              :data="realGoodsList"
              height="600"
              size="small"
              :row-class-name="tableRowClassName"
              :default-sort = "{prop: 'pay_amount', order: 'descending'}">
              <el-table-column prop="name" label="产品名称" width="220"/>
              <el-table-column prop="pay_amount" label="核销金额（本金）" align="center"  sortable />
              <el-table-column prop="num" label="核销数量" align="center" sortable />
              <el-table-column prop="cj_num" label="人数" align="center" sortable />
              <el-table-column prop="once_amount" label="单件金额"  align="center" sortable/>
            </el-table>
          </div>
        </el-col>
      </el-row>
    </div>
    
    <!-- 门店业绩表 -->
    <div class="charts-container" v-loading="loadingStates.shopPerform">
      <el-row>
        <el-col :span="24" class="table-container">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">{{name}}门店业绩表</div>
            <el-table
              :data="shopTableData"
              border
              size="small"
              :default-sort = "{prop: 'receipts', order: 'descending'}"
              :cell-style="$style.cellStyle"
              :row-class-name="tableRowClassName"
              :header-cell-style="$style.rowClass"
              >
              <el-table-column prop="shopName" label="门店" width="120"/>
              <el-table-column prop="receipts" label="实际收款金额" sortable />
              <el-table-column prop="receipts_gift" label="收款赠金" width="110" sortable />
              <el-table-column prop="contribution_rete" label="门店贡献度" sortable>
                <template slot-scope="{row}"> 
                  {{row.contribution_rete}}%
                </template>    
              </el-table-column>             
              <el-table-column prop="xd_perform" label="新单业绩"  width="110" sortable/>
              <el-table-column prop="bd_perform" label="补单业绩" width="110"  sortable/>
             <el-table-column prop="consume_amount" label="品项消耗金额" sortable/>
              <el-table-column prop="goods_consume_amount" label="商品出库金额" sortable/>
              <el-table-column prop="transfer_amount" label="转诊消耗金额" sortable/>
              <el-table-column prop="abnormal_consume_amount" label="异常消耗"  width="110" sortable/>
              <el-table-column prop="consume_sum_amount" label="消耗总额" width="110" sortable/>
              <ElTableColumn label="护理人数" prop="amount_care_num" sortable>
                <template #header>
                  <div style="display: flex; align-items: center; gap: 4px">
                    护理人数
                    <ElTooltip content="统计的是当前时间段内护理的人数（当前时间段内同一个客户护理多次只统计1次）" placement="top">
                      <i class="el-icon-question" style="color: #fff; cursor: pointer"></i>
                    </ElTooltip>
                  </div>
                </template>
              </ElTableColumn>
              <el-table-column prop="num_care" label="护理量" width="90" sortable/>
              <el-table-column prop="consume_avg" label="单次护理金额（本金）" width="120" sortable/>
            </el-table>
          </div>
        </el-col>
      </el-row>
    </div>
    
    <!-- 护理师业绩表（滚动加载 + 合计） -->
    <div class="charts-container" v-loading="loadingStates.personChannel">
      <el-row>
        <el-col :span="24" class="table-container">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">{{name}}护理师业绩表</div>
            <div 
              class="scrollable-table-container"
              ref="scrollContainer"
              @scroll="handleScroll"
            >
              <el-table
                :data="bodyTableData"
                border
                size="small"
                :default-sort = "{prop: 'receipts', order: 'descending'}"
                :cell-style="$style.cellStyle"
                :row-class-name="tableRowClassName"
                :header-cell-style="$style.rowClass"
                :show-header="true"
              >
                <el-table-column prop="name" label="护理师" width="120" fixed="left"/>
                <el-table-column prop="shop_name" label="所属门店" width="120"/>
                <el-table-column prop="receipts" label="实际收款金额" sortable />
                <el-table-column prop="receipts_gift" label="收款赠金" sortable />
                <el-table-column prop="contribution_rete" label="护理师贡献度" sortable>
                  <template slot-scope="{row}"> 
                    {{row.contribution_rete}}%
                  </template>    
                </el-table-column>             
                <el-table-column prop="xd_perform" label="新单业绩"  sortable/>
                <el-table-column prop="bd_perform" label="补单业绩"  sortable/>
                <el-table-column prop="consume_amount" label="品项消耗金额" sortable/>
                <el-table-column prop="goods_consume_amount" label="商品出库金额" sortable/>
                <el-table-column prop="transfer_amount" label="转诊消耗金额" sortable/>
                <el-table-column prop="abnormal_consume_amount" label="异常消耗" sortable/>
                <el-table-column prop="consume_sum_amount" label="消耗总额" sortable/>
                <ElTableColumn label="护理人数" prop="amount_care_num" sortable>
                  <template #header>
                    <div style="display: flex; align-items: center; ">
                      护理人数
                      <ElTooltip content="统计的是当前时间段内护理的人数（当前时间段内同一个客户护理多次只统计1次）" placement="top">
                        <i class="el-icon-question" style="color: #909399; cursor: pointer"></i>
                      </ElTooltip>
                    </div>
                  </template>
                </ElTableColumn>
                <el-table-column prop="num_care" label="护理量"  sortable/>
                <el-table-column prop="consume_avg" label="单次护理金额（本金）" sortable/>
              </el-table>
            <!-- 合计行（基于当前已加载数据计算） -->
            <div class="total-wrapper" v-if="!hasMore">
              <el-table
                :data="totalRowData"
                border
                size="small"
                :show-header="false"
                :cell-style="$style.totalCellStyle"
                class="total-table"
              >
                <el-table-column prop="name" label="护理师" width="120" fixed="left">
                  <template slot-scope="scope">
                    <strong>合计</strong>
                  </template>
                </el-table-column>
                <el-table-column prop="shop_name" label="所属门店" width="120">
                  <template slot-scope="scope">
                    —
                  </template>
                </el-table-column>
                <el-table-column prop="receipts" label="实际收款金额" sortable>
                  <template slot-scope="scope">
                    <strong>{{ formatNumber(scope.row.receipts) }}</strong>
                  </template>
                </el-table-column>
                <el-table-column prop="receipts_gift" label="收款赠金">
                  <template slot-scope="scope">
                    <strong>{{ formatNumber(scope.row.receipts_gift) }}</strong>
                  </template>
                </el-table-column>
                <el-table-column prop="contribution_rete" label="护理师贡献度">
                  <template slot-scope="scope">
                    <strong>{{ scope.row.contribution_rete }}%</strong>
                  </template>
                </el-table-column>
                <el-table-column prop="xd_perform" label="新单业绩">
                  <template slot-scope="scope">
                    <strong>{{ formatNumber(scope.row.xd_perform) }}</strong>
                  </template>
                </el-table-column>
                <el-table-column prop="bd_perform" label="补单业绩">
                  <template slot-scope="scope">
                    <strong>{{ formatNumber(scope.row.bd_perform) }}</strong>
                  </template>
                </el-table-column>
                <el-table-column prop="consume_amount" label="品项消耗金额">
                  <template slot-scope="scope">
                    <strong>{{ formatNumber(scope.row.consume_amount) }}</strong>
                  </template>
                </el-table-column>
                <el-table-column prop="goods_consume_amount" label="商品出库金额">
                  <template slot-scope="scope">
                    <strong>{{ formatNumber(scope.row.goods_consume_amount) }}</strong>
                  </template>
                </el-table-column>
                <el-table-column prop="transfer_amount" label="转诊消耗金额">
                  <template slot-scope="scope">
                    <strong>{{ formatNumber(scope.row.transfer_amount) }}</strong>
                  </template>
                </el-table-column>
                <el-table-column prop="abnormal_consume_amount" label="异常消耗">
                  <template slot-scope="scope">
                    <strong>{{ formatNumber(scope.row.abnormal_consume_amount) }}</strong>
                  </template>
                </el-table-column>
                <el-table-column prop="consume_sum_amount" label="消耗总额">
                  <template slot-scope="scope">
                    <strong>{{ formatNumber(scope.row.consume_sum_amount) }}</strong>
                  </template>
                </el-table-column>
                <el-table-column prop="amount_care_num" label="护理人数">
                  <template slot-scope="scope">
                    <strong>{{ formatNumber(scope.row.amount_care_num) }}</strong>
                  </template>
                </el-table-column>
                <el-table-column prop="num_care" label="护理量">
                  <template slot-scope="scope">
                    <strong>{{ formatNumber(scope.row.num_care) }}</strong>
                  </template>
                </el-table-column>
                <el-table-column prop="consume_avg" label="单次护理金额（本金）">
                  <template slot-scope="scope">
                    <strong>{{ formatNumber(scope.row.consume_avg) }}</strong>
                  </template>
                </el-table-column>
              </el-table>
            </div>
              <!-- 加载更多提示 -->
              <div class="load-more-trigger" v-if="hasMore">
                <div v-if="loadingMore" class="loading-more">
                  <i class="el-icon-loading"></i> 加载中...
                </div>
                <div v-else class="load-more-placeholder"></div>
              </div>
              
              <!-- 没有更多数据提示 -->
              <div class="no-more-data" v-if="!hasMore && bodyTableData.length > 0">
                没有更多数据了
              </div>
            </div>
            
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { ratingByMarket, questionByMarket, isShowMarketSearch,getMarket,getChannelEnterCustomer,goodsTop,getChannelData,serviceTop,shopQuestionScores,getPersonChannel,marketShopPerform,realServiceTop,shopEverydayPerform} from '@/api/sys'
import { mapGetters } from "vuex";

class Search {
  date = [];
  market_id = '';
  market_name = '';
}
class Page {
  page = 1;
  limit = 10;  // 每页20条
}

export default {
  props: {
    tabIndex: {
      type: Number,
      default: 0
    },
  },
  watch: {
    tabIndex(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getList();
      }
    }
  },
  computed: {
    ...mapGetters(["userInfo"]),
    // 计算合计行数据（基于当前已加载的数据）
    totalRowData() {
      if (!this.bodyTableData.length) return [];
      const total = {
        receipts: 0,
        receipts_gift: 0,
        contribution_rete: 0,
        xd_perform: 0,
        bd_perform: 0,
        consume_amount: 0,
        goods_consume_amount: 0,
        transfer_amount: 0,
        abnormal_consume_amount: 0,
        consume_sum_amount: 0,
        amount_care_num: 0,
        num_care: 0,
        consume_avg: 0
      };
      
      this.bodyTableData.forEach(item => {
        total.receipts += Number(item.receipts) || 0;
        total.receipts_gift += Number(item.receipts_gift) || 0;
        total.xd_perform += Number(item.xd_perform) || 0;
        total.bd_perform += Number(item.bd_perform) || 0;
        total.consume_amount += Number(item.consume_amount) || 0;
        total.goods_consume_amount += Number(item.goods_consume_amount) || 0;
        total.transfer_amount += Number(item.transfer_amount) || 0;
        total.abnormal_consume_amount += Number(item.abnormal_consume_amount) || 0;
        total.consume_sum_amount += Number(item.consume_sum_amount) || 0;
        total.amount_care_num += Number(item.amount_care_num) || 0;
        total.num_care += Number(item.num_care) || 0;
        total.consume_avg += Number(item.consume_avg) || 0;
      });
      
      // 贡献度平均值
      let totalContribution = 0;
      let validCount = 0;
      this.bodyTableData.forEach(item => {
        const val = Number(item.contribution_rete);
        if (!isNaN(val) && val !== 0) {
          totalContribution += val;
          validCount++;
        }
      });
      total.contribution_rete = validCount > 0 ? (totalContribution).toFixed(2) : '0.00';
      
      return [total];
    },
    // 是否还有更多数据
    hasMore() {
      return this.bodyTableData.length < this.totalCount;
    }
  },
  data() {
    const that = this; 
    return {
      page: new Page(),
      searchForm: new Search(),
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          if (minDate) {
            that.searchForm.date[0] = minDate.getTime(); 
          }
          if (maxDate) {
            that.searchForm.date[1] = maxDate.getTime(); 
          }
        },
        disabledDate: (time) => {
          const year = time.getFullYear();
          if (year <= 2024) {
            return true;
          }
          const currentTime = time.getTime();
          const now = Date.now();
          if (currentTime > now) {
            return true;
          }
          console.log(that.userInfo.id);
          if (that.userInfo.group_id == 96 || [1, 1737, 1901, 1916, 1917].includes(that.userInfo.id)) {
            return false;
          }

          if (that.searchForm.date[0]) {
            const startDate = new Date(that.searchForm.date[0]);
            const twoMonthsLater = new Date(startDate);
            twoMonthsLater.setMonth(twoMonthsLater.getMonth() + 2);
            const twoMonthsEarlier = new Date(startDate);
            twoMonthsEarlier.setMonth(twoMonthsEarlier.getMonth() - 2);
            return currentTime < twoMonthsEarlier || currentTime > twoMonthsLater;
          }
          return false;
        }
      },
      questionList1: [],
      shopScoreList: [],
      loadingStates: {
        questionDetail: false,
        dailyPerform: false,
        ratingByMarket: false,
        channelData: false,
        channelEnter: false,
        serviceGoods: false,
        shopPerform: false,
        realService: false,
        realGoods: false,
        personChannel: false
      },
      name: '',
      cjNum: 0,
      cjAmount: 0,
      showMarket: false,
      marketList: [],
      qList1: [],
      qList2: [],
      newList: [],
      allList: [],
      goodsList: [],
      serviceList: [],
      realServiceList: [],
      realGoodsList: [],
      qChart1: null,
      qChart2: null,
      qChart3: null,
      qChart4: null,
      qChart5: null,
      qChart6: null,
      qChart7: null,
      qChart8: null,
      list: [],
      shopTableData: [],
      bodyTableData: [],      // 已加载的数据列表
      totalCount: 0,          // 总数据条数
      moneyList: [],
      hlNum: 0,
      skAmount: 0,
      nChart1: null,
      nChart2: null,
      nChart3: null,
      nChart4: null,
      nChart5: null,
      nChart6: null,
      nChart7: null,
      nChart8: null,
      loadingMore: false,     // 是否正在加载更多
      scrollLoading: false,   // 防止重复触发滚动加载
      isFirstLoad: true       // 是否是首次加载
    }
  },
  
  mounted() {
    this.$nextTick(() => {
      this.initCharts();
      this.getList();
      window.addEventListener('resize', this.handleResize);
    });
  },
  
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.qChart1) this.qChart1.dispose();
    if (this.qChart2) this.qChart2.dispose();
    if (this.qChart3) this.qChart3.dispose();
    if (this.qChart4) this.qChart4.dispose();
    if (this.qChart5) this.qChart5.dispose();
    if (this.qChart6) this.qChart6.dispose();
    if (this.qChart7) this.qChart7.dispose();
    if (this.qChart8) this.qChart8.dispose();
    if (this.nChart1) this.nChart1.dispose();
    if (this.nChart2) this.nChart2.dispose();
    if (this.nChart3) this.nChart3.dispose();
    if (this.nChart4) this.nChart4.dispose();
    if (this.nChart5) this.nChart5.dispose();
    if (this.nChart6) this.nChart6.dispose();
    if (this.nChart7) this.nChart7.dispose();
    if (this.nChart8) this.nChart8.dispose();
  },
  
  methods: {
    // 格式化数字
    formatNumber(value) {
      if (value === undefined || value === null) return '0';
      const num = Number(value);
      if (isNaN(num)) return '0';
      if (Number.isInteger(num)) {
        return num.toLocaleString();
      }
      return num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    
    // 重置滚动状态（搜索时调用）
    resetScrollState() {
      this.bodyTableData = [];
      this.totalCount = 0;
      this.page.page = 1;
      this.loadingMore = false;
      this.scrollLoading = false;
      this.isFirstLoad = true;
    },
    
    // 滚动加载更多
    handleScroll(e) {
      if (this.scrollLoading) return;
      if (!this.hasMore) return;
      if (this.loadingMore) return;

      const container = e.target;
      const scrollTop = container.scrollTop;
      const scrollHeight = container.scrollHeight;
      const clientHeight = container.clientHeight;
      
      // 距离底部 50px 时触发加载
      if (scrollHeight - scrollTop - clientHeight < 50) {
        this.loadMore();
      }
    },
    
    // 加载更多数据（调用接口）
    async loadMore() {
      if (this.loadingMore) return;
      if (!this.hasMore && this.bodyTableData.length > 0) return;
      
      this.loadingMore = true;
      this.scrollLoading = true;
      
      // 页码+1
      this.page.page++;
      
      try {
        const [startTime, endTime] = this.searchForm.date || [];
        const params = {
          start_time: startTime || '',
          end_time: endTime || '',
          market_id: this.searchForm.market_id,
          page: this.page.page,
          limit: this.page.limit
        };
        
        const personRes = await getPersonChannel(params);
        const newData = personRes.data?.[0]?.list || [];
        const total = personRes.data?.[0]?.total || 0;
        
        this.totalCount = total;
        // 追加新数据
        this.bodyTableData = [...this.bodyTableData, ...newData];
        
      } catch (err) {
        console.error("加载更多失败：", err);
        this.$message.error("加载更多数据失败");
        // 加载失败时页码回退
        this.page.page--;
      } finally {
        this.loadingMore = false;
        this.scrollLoading = false;
      }
    },
    
    // 搜索时重置滚动状态
    handleSearch() {
      this.resetScrollState();
      this.getList();
    },
    
    // 初始化图表实例
    initCharts() {
      const qMain1Dom = document.getElementById('qMain1');
      const qMain2Dom = document.getElementById('qMain2');
      const qMain3Dom = document.getElementById('qMain3');
      const qMain5Dom = document.getElementById('qMain5');
      const qMain6Dom = document.getElementById('qMain6');
      const qMain7Dom = document.getElementById('qMain7');
      const qMain8Dom = document.getElementById('qMain8');
      const qMain9Dom = document.getElementById('qMain9');
      const qMain10Dom = document.getElementById('qMain10');

      const nMain1Dom = document.getElementById('nMain1');
      const nMain2Dom = document.getElementById('nMain2');
      const nMain3Dom = document.getElementById('nMain3');
      const nMain4Dom = document.getElementById('nMain4');
      const nMain5Dom = document.getElementById('nMain5');
      const nMain6Dom = document.getElementById('nMain6');
      const nMain7Dom = document.getElementById('nMain7');
      const nMain8Dom = document.getElementById('nMain8');
      
      if (nMain1Dom) this.nChart1 = echarts.init(nMain1Dom);
      if (nMain2Dom) this.nChart2 = echarts.init(nMain2Dom);
      if (nMain3Dom) this.nChart3 = echarts.init(nMain3Dom);
      if (nMain4Dom) this.nChart4 = echarts.init(nMain4Dom);
      if (nMain5Dom) this.nChart5 = echarts.init(nMain5Dom);
      if (nMain6Dom) this.nChart6 = echarts.init(nMain6Dom);
      if (nMain7Dom) this.nChart7 = echarts.init(nMain7Dom);
      if (nMain8Dom) this.nChart8 = echarts.init(nMain8Dom);
      
      if (qMain1Dom) this.qChart1 = echarts.init(qMain1Dom);
      if (qMain2Dom) this.qChart2 = echarts.init(qMain2Dom);
      if (qMain3Dom) this.qChart3 = echarts.init(qMain3Dom);
      if (qMain5Dom) this.qChart5 = echarts.init(qMain5Dom);
      if (qMain6Dom) this.qChart6 = echarts.init(qMain6Dom);
      if (qMain7Dom) this.qChart7 = echarts.init(qMain7Dom);
      if (qMain8Dom) this.qChart8 = echarts.init(qMain8Dom);
      if (qMain9Dom) this.qChart9 = echarts.init(qMain9Dom);
      if (qMain10Dom) this.qChart10 = echarts.init(qMain10Dom);
    },
    
    // 统一处理resize
    handleResize() {
      if (this.qChart1) this.qChart1.resize();
      if (this.qChart2) this.qChart2.resize();
      if (this.qChart3) this.qChart3.resize();
      if (this.qChart5) this.qChart5.resize();
      if (this.qChart6) this.qChart6.resize();
      if (this.qChart7) this.qChart7.resize();
      if (this.qChart8) this.qChart8.resize();
      if (this.qChart9) this.qChart9.resize();
      if (this.qChart10) this.qChart10.resize();
      
      if (this.nChart1) this.nChart1.resize();
      if (this.nChart2) this.nChart2.resize();
      if (this.nChart3) this.nChart3.resize();
      if (this.nChart4) this.nChart4.resize();
      if (this.nChart5) this.nChart5.resize();
      if (this.nChart6) this.nChart6.resize();
      if (this.nChart7) this.nChart7.resize();
      if (this.nChart8) this.nChart8.resize();
    },
    
    async getList() {
      try {
        Object.keys(this.loadingStates).forEach(key => {
          this.loadingStates[key] = true;
        });

        const showMarketRes = await isShowMarketSearch();
        this.showMarket = showMarketRes.data || false;

        if (this.showMarket) {
          const marketRes = await getMarket();
          this.marketList = marketRes.data || [];
        } else {
          this.marketList = [];
        }

        if (this.showMarket) {
          this.searchForm.market_id = this.searchForm.market_id ||
            (this.marketList.length > 0 ? this.marketList[0].market_id : '');
            const target = this.marketList.find(v => v.market_id === this.searchForm.market_id)
            this.searchForm.market_name = target ? target.market_name : ''
        } else {
          this.searchForm.market_id = '';
          this.searchForm.market_name = '';
        }
        this.name = this.searchForm.market_name || '';


        const [startTime, endTime] = this.searchForm.date || [];
        const commonParams = {
          start_time: startTime || '',
          end_time: endTime || '',
          market_id: this.searchForm.market_id
        };

        const shopRes = await shopEverydayPerform(commonParams).catch(err => {
          console.error("shopEverydayPerform 失败：", err);
          return { data: { list: [] } };
        });
        this.moneyList = shopRes.data?.list || [];
        this.name =  shopRes.data?.market_name || '';

        this.echartsEveDay(this.moneyList);
        this.loadingStates.dailyPerform = false;


        const questionRes = await questionByMarket({ market_id: this.searchForm.market_id}).catch(err => {
          console.error("questionByMarket 失败：", err);
          return { data: [] };
        });
        this.questionList = questionRes.data || [];
        this.getQ9Option(this.questionList);

        const ratingRes = await ratingByMarket({ market_id: this.searchForm.market_id}).catch(err => {
          console.error("ratingByMarket 失败：", err);
          return { data: [] };
        });
        this.ratingList = ratingRes.data || [];

        this.getQ10Option(this.ratingList);
        this.loadingStates.ratingByMarket = false;

        const questionDetailRes = await shopQuestionScores({ market_id: this.searchForm.market_id}).catch(err => {
          console.error("shopQuestionScores 失败：", err);
          return { data: [] };
        });
        this.questionList1 = questionDetailRes.data.questionList || [];
        this.shopScoreList = questionDetailRes.data.shopScoreList || [];
        this.loadingStates.questionDetail = false

        const channelRes = await getChannelData(commonParams).catch(err => {
          console.error("getChannelData 失败：", err);
          return { data: [] };
        });
        this.qList2 = channelRes.data || [];

        this.allList = this.qList2?.[0]?.list || [];
        const lastItem = this.allList[this.allList.length - 1] || {};
        this.cjNum = lastItem.cjCount || 0;
        this.echarts2(this.allList.length ? this.allList.slice(0, -1) : []);
        this.loadingStates.channelData = false;

        const enterRes = await getChannelEnterCustomer(commonParams).catch(err => {
          console.error("getChannelEnterCustomer 失败：", err);
          return { data: [] };
        });
        this.qList = enterRes.data || [];
        this.newList = this.qList?.[0]?.list || [];
        this.echarts1(this.newList.length ? this.newList.slice(0, -1) : []);
        this.loadingStates.channelEnter = false;

        const serviceRes = await serviceTop(commonParams).catch(err => {
          console.error("serviceTop 失败：", err);
          return { data: [] };
        });
        this.serviceList = serviceRes.data || [];
        this.loadingStates.serviceGoods = false;

        const goodsRes = await goodsTop(commonParams).catch(err => {
          console.error("goodsTop 失败：", err);
          return { data: [] };
        });
        this.goodsList = goodsRes.data || [];
        this.realGoodsList = this.goodsList;
        this.echartsRealGoods(this.realGoodsList.length ? this.realGoodsList.slice(0, -1) : []);
        this.loadingStates.realGoods = false;

        const realServiceRes = await realServiceTop(commonParams).catch(err => {
          console.error("realServiceTop 失败：", err);
          return { data: [] };
        });
        this.realServiceList = realServiceRes.data?.[0]?.list || [];
        this.echartsRealService(this.realServiceList.length ? this.realServiceList.slice(0, -1) : []);
        this.loadingStates.realService = false;
        const marketShopRes = await marketShopPerform(commonParams).catch(err => {
          console.error("marketShopPerform 失败：", err);
          return { data: [] };
        });
        this.shopTableData = marketShopRes.data?.[0]?.list || [];
        const lastShopItem = this.shopTableData[this.shopTableData.length - 1] || {};
        this.skAmount = lastShopItem.consume_amount || 0;
        this.cjAmount = lastShopItem.perform_sum || 0;
        this.hlNum = lastShopItem.amount_care_num || 0;
        this.echarts3(this.shopTableData.slice(0, -1));
        this.loadingStates.shopPerform = false;

        // ==============================================
        // 8. 第八个执行（护理师业绩表 - 后端分页滚动加载）
        // ==============================================
        await this.loadFirstPage();

      } catch (err) {
        console.error("接口请求出错：", err);
        this.$message.error("数据加载失败，请重试");
        Object.keys(this.loadingStates).forEach(key => {
          this.loadingStates[key] = false;
        });
      } finally {
        this.$nextTick(() => {
          this.handleResize();
        });
      }
    },
    
    // 加载第一页数据
    async loadFirstPage() {
      this.loadingStates.personChannel = true;
      this.page.page = 1;
      
      try {
        const [startTime, endTime] = this.searchForm.date || [];
        const params = {
          start_time: startTime || '',
          end_time: endTime || '',
          market_id: this.searchForm.market_id,
          page: this.page.page,
          limit: this.page.limit
        };
        
        const personRes = await getPersonChannel(params);
        const rawData = personRes.data?.[0]?.list || [];
        const total = personRes.data?.[0]?.total || 0;
        
        this.totalCount = total;
        // 过滤掉可能的合计行
        const lastRow = rawData[rawData.length - 1];
        if (lastRow && (lastRow.name === '合计' || lastRow.name === '总计' || lastRow.is_total)) {
          this.bodyTableData = rawData.slice(0, -1);
        } else {
          this.bodyTableData = rawData;
        }
        
      } catch (err) {
        console.error("loadFirstPage 失败：", err);
        this.bodyTableData = [];
        this.totalCount = 0;
      } finally {
        this.loadingStates.personChannel = false;
      }
    },

    echartsEveDay(jine) {
      if (!this.qChart8) return; 
      const nOption8 = {
        tooltip: {
          trigger: 'axis',
          textStyle: { align: 'left' },
          axisPointer: { type: 'shadow' },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              result += `${item.seriesName}: ${item.value}万元<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          right: 'center',
          top: '0%',
          data: ['业绩'], 
          selectedMode: 'single',
          textStyle: {}
        },
        grid: {
          left: '1%',
          right: '1%',
          bottom: '1%',
          top: '10%',
          containLabel: true
        },
        dataZoom: [
          {
            type: 'slider',
            show: jine.length > 10, 
            xAxisIndex: 0,
            start: 0,
            end: (30 / jine.length) * 100, 
            filterMode: 'filter', 
            bottom: 0,
          }
        ],
        xAxis: {
          type: 'category',
          data: jine.map(item => item.date),
          axisLine: { lineStyle: {} },
          axisLabel: { rotate: 45, interval: 0, color: '#000', fontSize: 12 }
        },
        yAxis: [
          {
            type: 'value',
            name: '金额（万元）',
            nameTextStyle: { color: '#666', fontSize: 12, padding: [0, 5, 0, 0] },
            axisLine: { show: false },
            axisLabel: { formatter: '{value}万元', color: '#666', fontSize: 12 },
            splitLine: { lineStyle: { color: '#CDD3E2' }}
          }
        ],
        series: [
          {
            name: '业绩',
            type: 'line',
            smooth: true,
            data: jine.map(item => (item.perform / 10000).toFixed(2)),
            barWidth: '40%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#F3C669' },
                { offset: 1, color: '#E49119' }
              ]),
              borderRadius: 4
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(243, 198, 105, 0.6)' },
                { offset: 1, color: 'rgba(228, 145, 25, 0.1)' } 
              ])
            },
            lineStyle: {
              width: 3,
              color: '#E49119'
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: params => params.value === 0 ? '' : params.value + '万元'
            }
          }
        ]
      };
      this.qChart8.setOption(nOption8);
    },
    
    echartsRealGoods(jine) {
      if (!this.nChart8) return;
      const sortedJine = [...jine].sort((a, b) => {
        return Number(b.pay_amount) - Number(a.pay_amount);
      });
      
      const nOption8 = {
        tooltip: {
          trigger: 'axis',
          textStyle: { align: 'left' },
          axisPointer: { type: 'shadow' },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              const unit = item.seriesName.includes('数量') ? '个' : 
                          item.seriesName.includes('核销额') ? '元' : '人';
              result += `${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          right: 'center',
          top: '0%',
          data: ['核销额', '数量', '人数'],
          selected: {
            '核销额': true,
            '数量': false,
            '人数': false
          },
          selectedMode: 'single',
          textStyle: {}
        },
        dataZoom: [
          {
            type: 'slider',
            show: jine.length > 10, 
            xAxisIndex: 0,
            start: 0,
            end: (30 / jine.length) * 100, 
            filterMode: 'filter', 
            bottom: 0
          }
        ],
        grid: {
          left: '3%',
          right: '3%',
          bottom: '1%',
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: sortedJine.map(item => item.name),
          axisLine: { lineStyle: {} },
          axisLabel: { rotate: 45, interval: 0, color: '#000', fontSize: 12 }
        },
        yAxis: [
          {
            type: 'value',
            name: '数量',
            nameTextStyle: { color: '#666', fontSize: 12, padding: [0, 0, 0, 5] },
            axisLine: { lineStyle: { color: '#3468E9' } },
            axisLabel: { formatter: '{value}', color: '#666', fontSize: 12 },
            splitLine: { lineStyle: { color: '#CDD3E2' } }
          },
          {
            type: 'value',
            name: '金额（元）',
            nameTextStyle: { color: '#666', fontSize: 12, padding: [0, 5, 0, 0] },
            axisLine: { show: false },
            axisLabel: { formatter: '{value}元', color: '#666', fontSize: 12 },
            splitLine: { lineStyle: { color: '#CDD3E2' }}
          }
        ],
        series: [
          {
            name: '核销额',
            type: 'bar',
            data: sortedJine.map(item => item.pay_amount),
            barWidth: '40%',
            yAxisIndex: 1,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#B6C2DC' },
                { offset: 1, color: '#4C5F8D' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: params => params.value === 0 ? '' : params.value + '元'
            }
          },
          {
            name: '数量',
            type: 'bar',
            data: sortedJine.map(item => item.num),
            barWidth: '40%',
            yAxisIndex: 0,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#79A7FE' },
                { offset: 1, color: '#3468E9' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: params => params.value === 0 ? '' : params.value + '个'
            }
          },
          {
            name: '人数',
            type: 'bar',
            data: sortedJine.map(item => item.cj_num),
            barWidth: '40%',
            yAxisIndex: 0,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#F3C669' },
                { offset: 1, color: '#E49119' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: params => params.value === 0 ? '' : params.value + '人'
            }
          }
        ]
      };
      this.nChart8.setOption(nOption8);
    },
    
    echartsRealService(jine) {
      if (!this.nChart7) return;
      const sortedJine = [...jine].sort((a, b) => {
        return Number(b.consume_count) - Number(a.consume_count);
      });
      const nOption7 = {
        tooltip: {
          trigger: 'axis',
          textStyle: { align: 'left' },
          axisPointer: { type: 'shadow' },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              const unit = item.seriesName.includes('护理量') ? '次' : 
                          item.seriesName.includes('金额') ? '元' : '人';
              result += `${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          right: 'center',
          top: '0%',
          data: ['核销数', '护理人数', '单次核销金额'],
          selected: {
            '护理人数': false,
            '单次核销金额': false,
            '核销数': true
          },
          selectedMode: 'single',
          textStyle: {}
        },
        dataZoom: [
          {
            type: 'slider',
            show: jine.length > 10, 
            xAxisIndex: 0,
            start: 0,
            end: (30 / jine.length) * 100, 
            filterMode: 'filter', 
            bottom: 0
          }
        ],
        grid: {
          left: '3%',
          right: '3%',
          bottom: '1%',
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: sortedJine.map(item => item.name),
          axisLine: { lineStyle: {} },
          axisLabel: { rotate: 45, interval: 0, color: '#000', fontSize: 12 }
        },
        yAxis: [
          {
            type: 'value',
            name: '数量',
            nameTextStyle: { color: '#666', fontSize: 12, padding: [0, 0, 0, 5] },
            axisLine: { lineStyle: { color: '#3468E9' } },
            axisLabel: { formatter: '{value}', color: '#666', fontSize: 12 },
            splitLine: { lineStyle: { color: '#CDD3E2' } }
          },
          {
            type: 'value',
            name: '金额（元）',
            nameTextStyle: { color: '#666', fontSize: 12, padding: [0, 5, 0, 0] },
            axisLine: { show: false },
            axisLabel: { formatter: '{value}元', color: '#666', fontSize: 12 },
            splitLine: { lineStyle: { color: '#CDD3E2' }}
          }
        ],
        series: [
          {
            name: '核销数',
            type: 'bar',
            data: sortedJine.map(item => item.consume_count),
            barWidth: '40%',
            yAxisIndex: 0,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#B6C2DC' },
                { offset: 1, color: '#4C5F8D' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: params => params.value === 0 ? '' : params.value + '次'
            }
          },
          {
            name: '护理人数',
            type: 'bar',
            data: sortedJine.map(item => item.serve_num),
            barWidth: '40%',
            yAxisIndex: 0,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#79A7FE' },
                { offset: 1, color: '#3468E9' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: params => params.value === 0 ? '' : params.value + '人'
            }
          },     
          {
            name: '单次核销金额',
            type: 'bar',
            data: sortedJine.map(item => item.once_serve_amount),
            barWidth: '40%',
            yAxisIndex: 1,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#F3C669' },
                { offset: 1, color: '#E49119' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: params => params.value === 0 ? '' : params.value + '元'
            }
          }
        ]
      };
      this.nChart7.setOption(nOption7);
    },
    getQ10Option(jine) {
      if (!this.qChart10) return;

      const baseColors = [
        '#2767FC', '#3491FA', '#4DA6FF', '#69B1FF',
        '#E49119', '#F3C669', '#FFD787', '#FFE8B3',
        '#36CFC9', '#5AD8A6', '#8AE29E', '#B7F0B3',
        '#D93F30', '#F56C6C', '#FF9E99', '#FFC7C2',
        '#722ED1', '#9370DB', '#B39DDB', '#D8C9F0',
        '#86909C', '#A8B0BD', '#C9CDD4', '#E5E6EB'
      ];

      const chartData = (jine.list || []).map(item => ({
        name: item.shop_name,
        value: item.avg_score
      }));

      const option = {
        color: baseColors,
        title: {
          text: jine.market_avg || '',
          textStyle: { fontSize: 32, color: '#2767FC', fontWeight: 'bold' },
          left: 'center',
          top: 'center',
        },
        tooltip: {
          trigger: 'item',
          formatter: params => `${params.name}：${params.value}分`
        },
        legend: { show: false },
        series: [{
          type: 'pie',
          radius: ['40%', '65%'],
          labelLine: { length: 30 },
          label: {
            formatter: params => `${params.name}：${params.value}分`,
            fontWeight: 'bold',
            fontSize: 14,
            backgroundColor: '#fff',
            padding: [8, 10],
            borderRadius: 4,
            borderWidth: 1
          },
          data: chartData
        }]
      };

      // 内部自动渲染 qChart9
      this.qChart10.setOption(option, true);
    },
    getQ9Option(jine) {
      // 先判断图表实例是否存在
      if (!this.qChart9) return;

      const baseColors = [
        '#2767FC', '#3491FA', '#4DA6FF', '#69B1FF',
        '#E49119', '#F3C669', '#FFD787', '#FFE8B3',
        '#36CFC9', '#5AD8A6', '#8AE29E', '#B7F0B3',
        '#D93F30', '#F56C6C', '#FF9E99', '#FFC7C2',
        '#722ED1', '#9370DB', '#B39DDB', '#D8C9F0',
        '#86909C', '#A8B0BD', '#C9CDD4', '#E5E6EB'
      ];

      // 数据适配
      const chartData = (jine.list || []).map(item => ({
        name: item.title,
        value: item.avg_score
      }));

      // 配置项
      const option = {
        color: baseColors,
        title: {
          text: jine.market_avg || '',
          textStyle: { fontSize: 32, color: '#2767FC', fontWeight: 'bold' },
          left: 'center',
          top: 'center',
        },
        tooltip: {
          trigger: 'item',
          formatter: params => `${params.name}：${params.value}分`
        },
        legend: { show: false },
        series: [{
          type: 'pie',
          radius: ['40%', '65%'],
          labelLine: { length: 30 },
          label: {
            formatter: (params) => {
              // 文本：名称 + 分数
              let text = `${params.name}：${params.value}分`;
              let result = [];
              for (let i = 0; i < text.length; i += 12) {
                result.push(text.slice(i, i + 12));
              }
              return result.join('\n');
            },
            fontWeight: 'bold',
            fontSize: 12,
            backgroundColor: '#fff',
            padding: [5, 8],
            borderRadius: 4,
            borderWidth: 1,
            
            // 👇 关键：允许换行 + 超出不省略
            overflow: 'break',
            whiteSpace: 'pre', // 必须加，才能识别 \n
            lineHeight: 18,
          },
          data: chartData
        }]
      };

      this.qChart9.setOption(option, true);
    },
   
    // 新客+老客
    echarts2(jine) {
      if (!this.qChart1) return;
      if (!this.qChart2) return;
      if (!this.qChart7) return;
      const baseColors = [
        '#2767FC', '#3491FA', '#4DA6FF', '#69B1FF',
        '#E49119', '#F3C669', '#FFD787', '#FFE8B3',
        '#36CFC9', '#5AD8A6', '#8AE29E', '#B7F0B3',
        '#D93F30', '#F56C6C', '#FF9E99', '#FFC7C2',
        '#722ED1', '#9370DB', '#B39DDB', '#D8C9F0',
        '#86909C', '#A8B0BD', '#C9CDD4', '#E5E6EB'
      ];

      const qOption1 = {
        color: baseColors,
        title: {
          text: this.cjAmount,
          textStyle: {
            fontSize: 32,
            color: '#2767FC',
            fontWeight: 'bold'
          },
          left: 'center',
          top: 'center',
        },
        tooltip: {
          trigger: 'item',
          formatter: function(params) {
            return params.value === 0 ? '' : `${params.name}: ${params.value}元 (${params.percent}%)`;
          }
        },
        legend: {
          orient: 'vertical',
          right: 'right',
          data: jine.filter(item => item.proceeds_balance !== 0).map(item => item.name),
          type: 'scroll',
          scrollDataIndex: 0,
          pageButtonPosition: 'end',
          pageIconSize: 10,
          show: false
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '65%'],
            labelLine: { length: 30 },
            label: {
              formatter: function(params) {
                if (params.value === 0) return '';
                return `${params.name}: ${params.value}元 \n(${params.percent}%)`;
              },
              fontWeight: 'bold',
              fontSize: 14,
              backgroundColor: 'rgba(255, 255, 255, 1)',
              padding: [8, 10],
              borderRadius: 4,
              borderWidth: 1
            },
            data: jine
              .filter(item => item.proceeds_balance !== 0)
              .map(item => ({
                name: item.name,
                value: item.proceeds_balance
              })),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      
      const qOption2 = {
        color: baseColors,
        title: {
          text: this.cjNum,
          textStyle: {
            fontSize: 32, 
            color: '#2767FC', 
            fontWeight: 'bold' 
          },
          left: 'center',
          top: 'center', 
        },
        tooltip: {
          trigger: 'item',
          formatter: function(params) {
            return params.value === 0 ? '' : `${params.name}: ${params.value}人 (${params.percent}%)`;
          }
        },
        legend: {
          orient: 'vertical',
          right: 'right',
          data: jine.filter(item => item.cjCount !== 0).map(item => item.name),
          type: 'scroll',
          scrollDataIndex: 0,
          pageButtonPosition: 'end',
          pageIconSize: 10,
          show: false
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '65%'],
            labelLine: { length: 30 },
            label: {
              formatter: function(params) {
                if (params.value === 0) return '';
                return `${params.name}: ${params.value}人 \n(${params.percent}%)`;
              },
              fontWeight: 'bold',
              fontSize: 14,
              backgroundColor: 'rgba(255, 255, 255, 1)',
              padding: [8, 10],
              borderRadius: 4,
              borderWidth: 1
            },
            data: jine.filter(item => item.cjCount !== 0).map(item => ({
              name: item.name,
              value: item.cjCount
            })),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      
      const qOption7 = {
        title: { show: false },
        tooltip: {
          trigger: 'axis',
          textStyle: { align: 'left' },
          axisPointer: { type: 'shadow' },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              const unit = item.seriesName.includes('转化率') ? '%' : '人';
              result += `${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          right: 'center',
          top: '4%',
          data: ['疤痕', '痘痘', '皮肤'],
          textStyle: {}
        },
        grid: {
          left: '1%',
          right: '1%',
          bottom: '1%',
          top: '12%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: jine.map(item => item.name),
          axisLine: { lineStyle: {} },
          axisLabel: { interval: 0 },
          scrollbar: {
            show: true,
            height: 8,
            bottom: 5,
            backgroundColor: 'transparent',
            handleColor: '#2767FC',
            handleSize: 15,
            showDataShadow: false,
            showDetail: false
          }
        },
        yAxis: [
          {
            type: 'value',
            name: '数量（人）',
            minInterval: 1,
            nameTextStyle: {},
            axisLine: { lineStyle: {} },
            axisLabel: { formatter: '{value}人' },
            splitLine: { lineStyle: { color: '#CDD3E2' } }
          }
        ],
        series: [
          {
            name: '疤痕',
            type: 'bar',
            data: jine.map(item => item.bhCjCount),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#79A7FE' },
                { offset: 1, color: '#3468E9' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '人';
              }
            }
          },
          {
            name: '痘痘',
            type: 'bar',
            data: jine.map(item => item.ddCjCount),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#B6C2DC' },
                { offset: 1, color: '#4C5F8D' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '人';
              }
            }
          },
          {
            name: '皮肤',
            type: 'bar',
            data: jine.map(item => item.pfCjCount),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#F3C669' },
                { offset: 1, color: '#E49119' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '人';
              }
            }
          }
        ]
      };
      
      this.qChart1.setOption(qOption1);
      this.qChart2.setOption(qOption2);
      this.qChart7.setOption(qOption7);
    },
    
    echarts1(jine) {
      if (!this.qChart3) return;
      if (!this.qChart5) return;
      if (!this.qChart6) return;
     
      const qOption3 = {
        title: { show: false },
        tooltip: {
          trigger: 'axis',
          textStyle: { align: 'left' },
          axisPointer: { type: 'shadow' },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              const unit = item.seriesName.includes('转化率') ? '%' : '人';
              result += `${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          left: 'center',
          top: '4%',
          data: ['获客数', '成交数', '进店数'],
          textStyle: {}
        },
        grid: {
          left: '1%',
          right: '1%',
          bottom: '1%',
          top: '12%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: jine.map(item => item.name),
          axisLine: { lineStyle: {} },
        },
        yAxis: [
          {
            type: 'value',
            name: '数量（人）',
            nameTextStyle: {},
            axisLine: { lineStyle: {} },
            axisLabel: { formatter: '{value}人' },
            splitLine: { lineStyle: { color: '#CDD3E2' } }
          }
        ],
        series: [
          {
            name: '获客数',
            type: 'bar',
            data: jine.map(item => item.gainCount),
            barWidth: '20%',
            barCategoryGap: '30%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: '#3468E9' },
                { offset: 0, color: '#79A7FE' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '人';
              }
            }
          },
          {
            name: '成交数',
            type: 'line',
            data: jine.map(item => item.cjCount),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#78DF69' },
                { offset: 1, color: '#78DF69' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '人';
              }
            }
          },    
          {
            name: '进店数',
            type: 'bar',
            data: jine.map(item => item.enterCount),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#ADBEDB' },
                { offset: 1, color: '#ADBEDB' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '人';
              }
            }
          },
        ]
      };
      
      const qOption5 = {
        title: { show: false },
        tooltip: {
          trigger: 'axis',
          textStyle: { align: 'left' },
          axisPointer: { type: 'shadow' },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              const unit = item.seriesName.includes('转化率') ? '%' : '人';
              result += `${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          right: 'center',
          top: '4%',
          data: ['疤痕', '痘痘', '皮肤'],
          textStyle: {}
        },
        grid: {
          left: '1%',
          right: '1%',
          bottom: '1%',
          top: '12%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: jine.map(item => item.name),
          axisLine: { lineStyle: {} },
          axisLabel: { interval: 0 },
          scrollbar: {
            show: true,
            height: 8,
            bottom: 5,
            backgroundColor: 'transparent',
            handleColor: '#2767FC',
            handleSize: 15,
            showDataShadow: false,
            showDetail: false
          }
        },
        yAxis: [
          {
            type: 'value',
            name: '数量（人）',
            nameTextStyle: {},
            axisLine: { lineStyle: {} },
            axisLabel: { formatter: '{value}人' },
            splitLine: { lineStyle: { color: '#CDD3E2' } }
          }
        ],
        series: [
          {
            name: '疤痕',
            type: 'bar',
            stack: "堆叠",
            data: jine.map(item => item.bhCjCount),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#79A7FE' },
                { offset: 1, color: '#3468E9' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '人';
              }
            }
          },
          {
            name: '痘痘',
            type: 'bar',
            data: jine.map(item => item.ddCjCount),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#B6C2DC' },
                { offset: 1, color: '#4C5F8D' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '人';
              }
            }
          },
          {
            name: '皮肤',
            type: 'bar',
            data: jine.map(item => item.pfCjCount),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#F3C669' },
                { offset: 1, color: '#E49119' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '人';
              }
            }
          }
        ]
      };
      
      const qOption6 = {
        title: { show: false },
        tooltip: {
          trigger: 'axis',
          textStyle: { align: 'left' },
          axisPointer: { type: 'shadow' },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              const unit = item.seriesName.includes('转化率') ? '%' : '人';
              result += `${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          right: 'center',
          top: '4%',
          data: [
            '进店-疤痕', '进店-痘痘', '进店-皮肤',
            '成交-疤痕', '成交-痘痘', '成交-皮肤'
          ],
          textStyle: { fontSize: 12 },
          formatter: function(name) {
            return name === '\n' ? '' : (name.includes('成交') ? '成交：' : '进店：') + name.split('-')[1];
          }
        },
        grid: {
          left: '1%',
          right: '1%',
          bottom: '1%',
          top: '12%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: jine.map(item => item.name),
          axisLine: { lineStyle: {} },
          axisLabel: { interval: 0 }
        },
        yAxis: [
          {
            type: 'value',
            name: '数量（人）',
            nameTextStyle: {},
            axisLine: { lineStyle: {} },
            axisLabel: { formatter: '{value}人' },
            splitLine: { lineStyle: { color: '#CDD3E2' } }
          }
        ],
        series: [
          {
            name: '进店-疤痕',
            type: 'bar',
            stack: '进店组',
            data: jine.map(item => item.bhEnterCount),
            barWidth: '25%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(81, 182, 246, 0.8)' },
                { offset: 1, color: 'rgba(33, 150, 243, 0.8)' }
              ]),
              borderRadius: [0, 0, 4, 4]
            },
            label: {
              show: true,
              fontSize: 12,
              color: 'white',
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '人';
              }
            }
          },
          {
            name: '进店-痘痘',
            type: 'bar',
            stack: '进店组',
            data: jine.map(item => item.ddEnterCount),
            barWidth: '25%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#ADBEDB' },
                { offset: 1, color: '#ADBEDB' }
              ]),
              borderRadius: [0, 0, 4, 4]
            },
            label: {
              show: true,
              fontSize: 12,
              color: 'white',
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '人';
              }
            }
          },
          {
            name: '进店-皮肤',
            type: 'bar',
            stack: '进店组',
            data: jine.map(item => item.pfEnterCount),
            barWidth: '25%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(252, 211, 77, 0.8)' },
                { offset: 1, color: 'rgba(245, 158, 11, 0.8)' }
              ]),
              borderRadius: [0, 0, 4, 4]
            },
            label: {
              show: true,
              fontSize: 12,
              color: 'white',
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '人';
              }
            }
          },
          {
            name: '成交-疤痕',
            type: 'bar',
            stack: '成交组',
            data: jine.map(item => item.bhCjCount),
            barWidth: '25%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#E91E63' },
                { offset: 1, color: '#E91E63' }
              ]),
              borderRadius: [4, 4, 0, 0]
            },
            label: {
              show: true,
              fontSize: 12,
              color: 'white',
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '人';
              }
            }
          },
          {
            name: '成交-痘痘',
            type: 'bar',
            stack: '成交组',
            data: jine.map(item => item.ddCjCount),
            barWidth: '25%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#2196F3' },
                { offset: 1, color: '#2196F3' }
              ]),
              borderRadius: [4, 4, 0, 0]
            },
            label: {
              show: true,
              fontSize: 12,
              color: 'white',
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '人';
              }
            }
          },
          {
            name: '成交-皮肤',
            type: 'bar',
            stack: '成交组',
            data: jine.map(item => item.pfCjCount),
            barWidth: '25%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#00BCD4' },
                { offset: 1, color: '#00BCD4' }
              ]),
              borderRadius: [4, 4, 0, 0]
            },
            label: {
              show: true,
              fontSize: 12,
              color: 'white',
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '人';
              }
            }
          }
        ]
      };

      this.qChart3.setOption(qOption3);
      this.qChart5.setOption(qOption5);
      this.qChart6.setOption(qOption6);
    },
    
    echarts3(jine) {
      if (!this.nChart1) return;
      if (!this.nChart2) return;
      if (!this.nChart3) return;
      if (!this.nChart4) return;
      if (!this.nChart5) return;
      if (!this.nChart6) return;

      const professionalColors1 = ['#6A98E4', '#2767FC', '#85D4EE', '#EB5B73', '#FFA06C', '#376473', '#31c5e9'];
      const professionalColors2 = ['#9FE6B8', '#32C5E9', '#2767FC', '#9D96F5', '#E062AE', '#FFA06C', '#FEDB65'];

      const nOption1 = {
        title: {
          text: this.skAmount,
          textStyle: {
            fontSize: 32, 
            color: '#2767FC', 
            fontWeight: 'bold'
          },
          left: 'center',
          top: 'center', 
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c}元 ({d}%)'
        },
        legend: { show: false },
        series: [
          {
            type: 'pie',
            radius: ['40%', '65%'],
            labelLine: { length: 30 },
            label: {
              formatter: '{b}: {c}元 \n({d}%)',
              fontWeight: 'bold',
              fontSize: 14,
              backgroundColor: 'rgba(255, 255, 255, 1)', 
              padding: [8, 10], 
              borderRadius: 4, 
              borderWidth: 1 
            },
            data: jine.map(item => ({
              name: item.shopName,
              value: item.consume_amount
            })),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }                 
          } 
        ]
      };
      
      const nOption2 = {
        color: professionalColors2,
        title: {
          text: this.hlNum,
          textStyle: {
            fontSize: 32,
            color: '#2767FC',
            fontWeight: 'bold'
          },
          left: 'center',
          top: 'center', 
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c}人 ({d}%)'
        },
        legend: { show: false },
        series: [
          {
            type: 'pie',
            radius: ['40%', '65%'],
            labelLine: { length: 30 },
            label: {
              formatter: '{b}: {c}人 \n({d}%)',
              fontWeight: 'bold',
              fontSize: 14,
              backgroundColor: 'rgba(255, 255, 255, 1)',
              padding: [8, 10],
              borderRadius: 4,
              borderWidth: 1
            },
            data: jine.map(item => ({
              name: item.shopName,
              value: item.amount_care_num
            })),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ],
      };
      
      const nOption3 = {
        tooltip: {
          trigger: 'axis',
          textStyle: { align: 'left' },
          axisPointer: { type: 'shadow' },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              const unit = item.seriesName.includes('护理师贡献度') ? '%' : '元';
              result += `${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          left: 'center',
          top: '0%',
          data: ['门店业绩', '门店消耗额'],
          textStyle: {}
        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: '1%',
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: jine.map(item => item.shopName),
          axisLine: { lineStyle: {} },
          axisLabel: { rotate: 45, interval: 0, color: '#000', fontSize: 12 }
        },
        yAxis: [
          {
            type: 'value',
            name: '数量（元）',
            nameTextStyle: {},
            axisLine: { lineStyle: {} },
            axisLabel: { formatter: '{value}元' },
            splitLine: { lineStyle: { color: '#CDD3E2' } }
          }
        ],
        series: [
          {
            name: '门店业绩',
            type: 'bar',
            data: jine.map(item => item.perform_sum),
            barWidth: '20%',
            barCategoryGap: '30%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: '#3468E9' },
                { offset: 0, color: '#79A7FE' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '元';
              }
            }
          },
          {
            name: '门店消耗额',
            type: 'bar',
            data: jine.map(item => item.consume_amount),
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: { color: '#78DF69', width: 2 },
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#F3C669' },
                { offset: 1, color: '#E49119' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '元';
              }
            }
          }
        ]
      };

      const nOption4 = {
        title: { show: false },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          textStyle: { align: 'left' },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              const unit = item.seriesName.includes('赠送比例') ? '%' : '元';
              result += `${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          left: 'center',
          top: '0%',
          data: ['业绩', '收款赠金', '赠送比例'],
          textStyle: {}
        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: '1%',
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: jine.map(item => item.shopName),
          axisLine: { lineStyle: {} },
          axisLabel: { rotate: 45, interval: 0, color: '#000', fontSize: 12 }
        },
        yAxis: [
          {
            type: 'value',
            name: '数量（元）',
            nameTextStyle: { color: '#666', fontSize: 12, padding: [0, 0, 0, 5] },
            axisLine: { lineStyle: { color: 'red' } },
            axisLabel: { formatter: '{value}元', color: '#666', fontSize: 12 },
            splitLine: { lineStyle: { color: '#CDD3E2' } }
          },
          {
            type: 'value',
            name: '比例',
            nameTextStyle: { color: '#666', fontSize: 12, padding: [0, 5, 0, 0] },
            axisLine: { show: true, lineStyle: { color: 'none' } },
            axisLabel: { formatter: '{value}%', color: '#666', fontSize: 12 },
            splitLine: { show: false }
          }
        ],
        series: [
          {
            name: '业绩',
            type: 'bar',
            yAxisIndex: 0,
            data: jine.map(item => item.perform_sum),
            barWidth: '20%',
            barCategoryGap: '30%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: '#3468E9' },
                { offset: 0, color: '#79A7FE' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '元';
              }
            }
          },
          {
            name: '收款赠金',
            type: 'bar',
            yAxisIndex: 0,
            data: jine.map(item => item.receipts_gift),
            barWidth: '20%',
            barCategoryGap: '30%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#F3C669' },
                { offset: 1, color: '#E49119' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '元';
              }
            }
          },
          {
            name: '赠送比例',
            type: 'line',
            yAxisIndex: 1,
            data: jine.map(item => {
              const gift = Number(item.receipts_gift) || 0;
              const total = Number(item.receipts) || 0;
              return total === 0 ? 0 : Number(((gift / total) * 100).toFixed(2));
            }),
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: { color: '#78DF69', width: 2 },
            itemStyle: { color: '#78DF69', borderRadius: 4 },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '%';
              }
            }
          }
        ]
      };
      
      const nOption5 = {
        title: { show: false },
        tooltip: {
          trigger: 'axis',
          textStyle: { align: 'left' },
          axisPointer: { type: 'shadow' },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              const unit = item.seriesName.includes('转化率') ? '%' : '元';
              result += `${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          right: 'center',
          top: '0%',
          data: ['新单业绩', '补单业绩'],
          textStyle: {}
        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: '1%',
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: jine.map(item => item.shopName),
          axisLine: { lineStyle: {} },
          axisLabel: { rotate: 45, interval: 0, color: '#000', fontSize: 12 }
        },
        yAxis: [
          {
            type: 'value',
            name: '数量（元）',
            nameTextStyle: {},
            axisLine: { lineStyle: {} },
            axisLabel: { formatter: '{value}元' },
            splitLine: { lineStyle: { color: '#CDD3E2' } }
          }
        ],
        series: [
          {
            name: '新单业绩',
            type: 'bar',
            data: jine.map(item => item.xd_perform),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#79A7FE' },
                { offset: 1, color: '#3468E9' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '元';
              }
            }
          },
          {
            name: '补单业绩',
            type: 'bar',
            data: jine.map(item => item.bd_perform),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#F3C669' },
                { offset: 1, color: '#E49119' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '元';
              }
            }
          }
        ]
      };
      
      const nOption6 = {
        title: { show: false },
        tooltip: {
          trigger: 'axis',
          textStyle: { align: 'left' },
          axisPointer: { type: 'shadow' },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              const unit = item.seriesName.includes('护理量') ? '次' : 
                          item.seriesName.includes('金额') ? '元' : '人';
              result += `${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          right: 'center',
          top: '0%',
          data: ['护理人数', '护理量', '单次护理金额（本金）'],
          textStyle: {}
        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: '1%',
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: jine.map(item => item.shopName),
          axisLine: { lineStyle: {} },
          axisLabel: { rotate: 45, interval: 0, color: '#000', fontSize: 12 }
        },
        yAxis: [
          {
            type: 'value',
            name: '数量',
            nameTextStyle: { color: '#666', fontSize: 12, padding: [0, 0, 0, 5] },
            axisLine: { lineStyle: { color: '#3468E9' } },
            axisLabel: { formatter: '{value}', color: '#666', fontSize: 12 },
            splitLine: { lineStyle: { color: '#CDD3E2' } }
          },
          {
            type: 'value',
            name: '金额（元）',
            nameTextStyle: { color: '#666', fontSize: 12, padding: [0, 5, 0, 0] },
            axisLine: { show: false },
            axisLabel: { formatter: '{value}元', color: '#666', fontSize: 12 },
            splitLine: { show: false }
          }
        ],
        series: [
          {
            name: '护理人数',
            type: 'bar',
            data: jine.map(item => item.amount_care_num),
            barWidth: '20%',
            yAxisIndex: 0,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#79A7FE' },
                { offset: 1, color: '#3468E9' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '人';
              }
            }
          },
          {
            name: '护理量',
            type: 'bar',
            data: jine.map(item => item.num_care),
            barWidth: '20%',
            yAxisIndex: 0,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#B6C2DC' },
                { offset: 1, color: '#4C5F8D' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '次';
              }
            }
          },
          {
            name: '单次护理金额（本金）',
            type: 'bar',
            data: jine.map(item => item.consume_avg),
            barWidth: '20%',
            yAxisIndex: 1,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#F3C669' },
                { offset: 1, color: '#E49119' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '元';
              }
            }
          }
        ]
      };

      this.nChart1.setOption(nOption1);
      this.nChart2.setOption(nOption2);
      this.nChart3.setOption(nOption3);
      this.nChart4.setOption(nOption4);
      this.nChart5.setOption(nOption5);
      this.nChart6.setOption(nOption6);
    },
    
    tableRowClassName({row, rowIndex}) {
      if (rowIndex % 2 == 0) {
        return 'ou-row';
      } else {
        return 'ji-row';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-table__footer-wrapper .el-table__cell {
  text-align: center !important;
  font-weight: bold !important; 
}
::v-deep .el-table tr.ou-row {
  background-color: #EEF6FF;
}
::v-deep .el-table tr.ji-row {
  background-color: #D4E6F4;
}

::v-deep .el-table__cell {
  color: #2861C0 !important;
  color: #333333 !important;
  font-weight: 600;
  font-size: 15px;
}

::v-deep .el-table__header .el-table__cell {
  background: #C2DBF9 !important;
  color: #000000 !important;
}

.flex {
  color: #333;
  width: 95%;
  margin: 0 auto;
  margin-bottom: 4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  div {
    font-size: 1.2rem;
    padding: 1.5rem 3rem;
    border: 1px solid #EDF2FF;
    border-radius: 0.5rem;
    box-shadow: inset 0 0 0.5rem #EDF2FF;
    background-color: #EDF2FF;
    overflow: hidden;
    text-align: center;
    span {
      display: block; 
      font-size: 2.5rem;
      line-height: 3rem;
      margin-bottom: 0.3rem;
    }
  }
}

.charts-container {
  margin: 20px 0;
  text-align: center;
  .table-title {
    display: inline-block; 
    font-size: 1.5rem;
    font-weight: 600;
    color: #fff;
    background: #79A7FE;
    padding: 1rem;
    border-radius: 1rem;
  }
}

.chart-wrapper {
  width: 100%;
  box-sizing: border-box;
  background: #EDF2FF;
  padding: 2%;
  border-radius: 3rem;
}

.chart-content {
  width: 100%;
  height: 540px;
}

/* 可滚动表格容器 */
.scrollable-table-container {
  max-height: 450px;
  overflow-y: auto;
  position: relative;
}

/* 加载更多触发器区域 */
.load-more-trigger {
  min-height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-more {
  padding: 16px;
  text-align: center;
  color: #666;
  font-size: 14px;
}

.load-more-placeholder {
  height: 20px;
}

.no-more-data {
  padding: 16px;
  text-align: center;
  color: #999;
  font-size: 14px;
}

/* 合计表格样式 */
.total-wrapper {
  margin-top: 16px;
  border-radius: 0 0 1rem 1rem;
  overflow: hidden;
}

.total-table {
  ::v-deep .el-table__body-wrapper {
    background: #D4E6F4;
  }
  ::v-deep .el-table__row {
    background-color: #D4E6F4 !important;
  }
  ::v-deep .el-table__cell {
    background-color: #D4E6F4 !important;
    font-weight: 400 !important;
    text-align: center !important;
  }
}
</style>